import Vue from 'vue'
import { store } from './store/store'

// Axios configs for async requests to the API

axios.authURL = (process.env.API_AUTH_SERVER !== undefined)
    ? process.env.API_AUTH_SERVER
    : 'http://qa-api-resourceserver-pluralo.azurewebsites.net/api/';

axios.defaults.baseURL = (process.env.API_RESOURCES_SERVER !== undefined)
    ? process.env.API_RESOURCES_SERVER
    : 'http://qa-api-resourceserver-pluralo.azurewebsites.net/';

// PROD
// axios.authURL = 'http://prod-api-authenticationserver-pluralo.azurewebsites.net/';
// axios.defaults.baseURL = 'http://prod-api-resourceserver-pluralo.azurewebsites.net/';
// QA
// axios.authURL = 'http://qa-api-authenticationserver-pluralo.azurewebsites.net/';
// axios.defaults.baseURL = 'http://qa-api-resourceserver-pluralo.azurewebsites.net/';
// DEV
// axios.authURL = 'http://dev-api-authenticationserver-pluralo.azurewebsites.net/';
// axios.defaults.baseURL = 'http://dev-api-resourceserver-pluralo.azurewebsites.net/';
// TEMP
// axios.authURL = 'http://temp-api-authenticationserver-ln-pluralo.azurewebsites.net/';
// axios.defaults.baseURL = 'http://temp-api-resourceserver-ln-pluralo.azurewebsites.net/';
// LOCALHOST
// axios.authURL = 'http://localhost:61143/';
// axios.defaults.baseURL = 'http://localhost:47039/';

axios.defaults.headers.common['Authorization'] = localStorage.getItem('pluralo_token') ? `Bearer ${localStorage.getItem('pluralo_token')}` : null;

// We need to refresh the data from our account before anything else (async call)


axios.interceptors.request.use(function (response) {
    let token = localStorage.getItem('pluralo_token');

    Vue.prototype.$Progress.start();

    response.headers['Authorization'] = token ? `Bearer ${token}` : null;

    return response;
}, function (error) {
    Vue.prototype.$Progress.fail();
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    Vue.prototype.$Progress.finish();
    if(response.data === null){
        return null
    }
    // this is used for when the server needs to send data with the response, this can be for example a warning on a successful response
    if(response && response.data.serverInfo){

        if(response.data.serverInfo.isToShowServerInfo && response.data.serverInfo.isToShowServerInfo == true){
            store.dispatch('richPrompt', response.data.serverInfo).then(response => {
                console.log(response);
            }).catch(err => {
                console.log(err);
            })
        }

        response.serverInfo = response.data.serverInfo
        response.data = response.data.serverResponse
    }

    return response;
}, function (error) {


    // this is used for when the server needs to send data with the response, this can be for example a warning on a successful response
    if(error.response && error.response.data.serverInfo){

        if(error.response.data.serverInfo.isToShowServerInfo && error.response.data.serverInfo.isToShowServerInfo == true){
            store.dispatch('richPrompt', error.response.data.serverInfo).then(response => {
                console.log(response);
            }).catch(err => {
                console.log(err);
            })
        }

        error.response.serverInfo = error.response.data.serverInfo
        error.response.data = error.response.data.serverResponse
    }

    Vue.prototype.$Progress.fail();

    console.log("response 404 => ", error)

    if (error.response.status === 400) {
        console.log('Error 400', error.response);


        if (error.response.data !== undefined && error.response.data && error.response.data.message !== undefined && error.response.data.message) {


            if(error.response.data.messageDetails){
                let errorMessageDetails = '';
                errorMessageDetails = errorMessageDetails + '<div>' + error.response.data.message + '<div>';
                for (let messageDetail of error.response.data.messageDetails) {
                    errorMessageDetails = errorMessageDetails + '<div>' + messageDetail + '<div>';
                }
                Vue.toasted.error(errorMessageDetails);
            } else {
                Vue.toasted.error(error.response.data.message);
            }

        }
    } else if (error.response.status === 401) {
        store.dispatch('clientLogout');
    } else if (error.response.status === 404) {
        return;
    }


    return Promise.reject(error);
});

// Protect guarded routes or move forward if possible.
// All routes are bound to the progress bar automatically

Vue.router.beforeEach((to, from, next) => {
    let loginPath = 'auth.login';
    let token = localStorage.getItem('pluralo_token');

    // Start loading indicator

    Vue.prototype.$Progress.start();

    // Set a custom title if any

    if (to.meta.title !== undefined) {
        document.title = to.meta.title;
    }

    // Trying to access a protected route? Redirect to login page

    if (to.matched.some(record => record.meta.protected) && !token) {
        next({ name: loginPath, query: { redirect: to.name }});
    }
    // Trying to access the login page while logged in? Go back

    else if (to.matched.some(record => record.name === loginPath) && token) {
        next({ path: from.path });
    }
    else {
        next();
    }
});

Vue.router.afterEach((to, from) => {
    // Finish loading indicator

    Vue.prototype.$Progress.finish();
});



// WEBPACK FOOTER //
// ./src/transport.js